import { render, staticRenderFns } from "./FriendsFindNewFriends.vue?vue&type=template&id=a2654c6e&lang=pug&"
import script from "./FriendsFindNewFriends.vue?vue&type=script&lang=js&"
export * from "./FriendsFindNewFriends.vue?vue&type=script&lang=js&"
import style0 from "./FriendsFindNewFriends.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports